import styled from "styled-components";

export const TopRightPositionWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;
